module.exports = __webpack_public_path__ + "static/media/ucon8.945ae6fe.JPG";